<template>
  <div class="c_table_wrap">
    <table class="memberInfo_table">
      <colgroup>
        <col width="150px;">
        <col width="">
      </colgroup>
      <tr>
        <td class="c_t_title">
          분야순서
        </td>
        <td class="write_content_td">
          <div class="write_content_div">
            <el-input v-model="seq" maxLength="20"></el-input>
            <div class="input_error" v-show="disabled">직접입력의 경우 순서만 변경 가능합니다.</div>
            <div class="input_error">{{ validation.firstError('seq') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">
          분야명(한국어)
        </td>
        <td class="write_content_td">
          <div class="write_content_div">
            <el-input v-model="kor" :disabled="disabled"></el-input>
            <div class="input_error">{{ validation.firstError('kor') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">
          분야명(영어)
        </td>
        <td class="write_content_td">
          <div class="write_content_div">
            <el-input v-model="eng" :disabled="disabled"></el-input>
            <div class="input_error">{{ validation.firstError('eng') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">
          분야명(중국어)
        </td>
        <td class="write_content_td">
          <div class="write_content_div">
            <el-input v-model="cn" :disabled="disabled"></el-input>
            <div class="input_error">{{ validation.firstError('cn') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">
          노출
        </td>
        <td class="write_content_td">
            <div class="select_wrap">
              <el-select v-model="display" :disabled="disabled">
                <el-option :label="'노출'" :value="1"></el-option>
                <el-option :label="'미노출'" :value="0"></el-option>
              </el-select>
          </div>
        </td>
      </tr>
    </table>
    <div class="input_error text_center pt10" v-show="errorMsg !==''">{{ errorMsg }}</div>
  </div>
</template>

<script>

import categoryValidator from "@/mixins/validators/categoryValidator";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";

export default {
  name: "CategoryWriteComponent",
  mixins: [categoryValidator,alertMixins],
  components: {

  },
  provide() {
    return {}
  },
  inject: ['changeLoading'],
  props: {
    index: {default: 0},
    categoryData : {
      default: () => {
      }
    },
    afterFunc: {default: () => {}},
    categoryType: ''
  },
  data() {
    return {
      disabled :false,
      errorMsg:'',
      categoryKey :0,
      writeFunc:'',
    }
  },
  created() {
    if(this.hasData){ // 수정
      this.initData();
    }
  },
  mounted() {
    EventBus.$on('writeCategory', this.writeCategory);
  },
  beforeDestroy() {
    EventBus.$off('writeCategory')
  },
  destroyed() {
  },
  computed: {},
  methods: {
    hasData(){
      return !util.isEmpty(this.categoryData) && !util.isEmpty(this.index)
    },
    initData(){
      let idx = this.index
      this.display = this.categoryData[idx].oc_display ;
      this.seq = this.categoryData[idx].oc_seq;
      this.kor = this.categoryData[idx].oc_kor;
      this.cn = this.categoryData[idx].oc_cn;
      this.eng = this.categoryData[idx].oc_eng;

      this.categoryKey = this.categoryData[idx].oc_idx;

      if(this.categoryData[idx].oc_lock === 1){
        this.disabled = true;
      }
    },
    writeCategory(){
      this.changeLoading(true);
      this.$validate(['eng','kor','cn','display','seq']).then((success) => {
        if(!success) {
          this.changeLoading(false);
          this.errorMsg = '입력값을 확인해주세요.'
          return
        }

        this.errorMsg = ''
        let params = {
            oc_eng : this.eng,
            oc_kor : this.kor,
            oc_cn : this.cn,
            oc_seq : this.seq,
            oc_display : this.display,
            oc_type: this.categoryType
        }

        if(this.categoryKey !== 0){
          params.oc_idx = this.categoryKey
           this.writeFunc = 'updateCategory'
        }else {
          this.writeFunc= 'createCategory'
        }

        try {
          this.$api.$online[this.writeFunc](params).then(res => res.Data.Result).then(res => {
            let type = this.returnCategoryWriteType(res.Info.type);
            if(type != true) {
              this.changeLoading(false);
              this.errorAlert(type);
              return false;
            }else {
              this.changeLoading(false);
              this.afterFunc()
            }
          })
        }catch (e) {
          this.changeLoading(false);
          console.log(e)
        }

      })
    },
    returnCategoryWriteType(type) {
      switch (type){
        case 1 :
          return true
        case -403 :
          return '권한이 없습니다.'
        case -100 :
          return '필수값이 없습니다.'
        case -101 :
          return '유효성 실패입니다.'
        case -300 :
          return '한국명 중복입니다.'
        case -301 :
          return '영문명 중복입니다.'
        case -302 :
          return '중문명 중복입니다.'
        default :
          return '저장에 실패하였습니다.'
      }
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>